'use client';

import { getAlreadyViewNewsLocalStorage, storeAlreadyViewToLocalStorage } from '@fe-news/utils/news';

const AddAlreadyView = ({ newsId }: { newsId: number }) => {
  const isAlreadyView = getAlreadyViewNewsLocalStorage().includes(newsId.toString());

  if (!isAlreadyView) {
    storeAlreadyViewToLocalStorage(newsId);
  }

  return null;
};

export default AddAlreadyView;
